<template>
    <div class="order">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>订单列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="订单号:">
                    <el-input v-model="query.orderNo" placeholder="订单编号"></el-input>
                </el-form-item>
                <el-form-item label="产品序列号:">
                    <el-input v-model="query.deviceName" placeholder="产品序列号"></el-input>
                </el-form-item>
                <el-form-item label="所属企业" prop="epId" >
                    <el-select v-model="query.epId" placeholder="请选择" filterable>
                        <el-option
                                v-for="item in enterprises"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备型号" prop="standardId" >
                    <el-select v-model="query.deviceTypeId" filterable placeholder="请选择">
                        <el-option
                                v-for="item in standards"
                                :key="item.id"
                                :label="item.name + '-' + item.model"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <br/>
                <el-form-item label="时间范围:">
                    <el-date-picker
                            v-model="query.dateTimeRange"
                            @change="onTimeRangeChange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-table
                    :data="orders"
                    border
                    v-loading="loading"
                    style="width: 100%">
                <!--<el-table-column type="expand">
                    <template slot-scope="props">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>收货详情</span>
                            </div>
                            <div>
                                <div style="margin-bottom: .5rem">收货人：{{ props.row.address.name }}</div>
                                <div style="margin-bottom: .5rem">手机号：{{ props.row.address.phone }}</div>
                                <div style="margin-bottom: .5rem">地址：{{ props.row.address.address }}</div>
                                <div style="margin-bottom: .5rem">备注：{{ props.row.address.remark }}</div>
                            </div>
                        </el-card>
                    </template>
                </el-table-column>-->
                <el-table-column
                        prop="orderNo"
                        sortable
                        label="订单编号"
                        >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="订单时间">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="amount"
                        label="订单金额"
                >
                    <template slot-scope="scope">
                        {{scope.row.amount}}元
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="type"
                        label="订单类型"
                >
                    <template slot-scope="scope">
                        {{scope.row.type == 1 ? '个人订单' : scope.row.type == 2 ?  '企业订单' : "平台充值"}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="deviceSerialNo"
                        label="产品序列号"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.deviceName ? a.deviceName.localeCompare(b.deviceName, 'zh') : -1"
                        prop="deviceName"
                        label="设备名称"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="deviceModel"
                        label="设备型号"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.epName ? a.epName.localeCompare(b.epName, 'zh') : -1"
                        prop="epName"
                        label="企业名称"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="phone"
                        label="手机号"
                >
                    <template slot-scope="scope">
                        {{scope.row.phone || "-"}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="rechargeTimes"
                        label="充值次数"
                >
                </el-table-column>
                <el-table-column
                        label="订单状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status == 0 ? 'info' : scope.row.status == 1 ? '' : 'success'" effect="dark">{{scope.row.status == 0 ? "未支付" : scope.row.status == 1 ? "已支付" : "已完成"}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="showDialog(scope.row)" v-if="scope.row.status == 0 && auth.accountType != 1">订单改价</el-button>
                        <el-button type="danger" size="mini" @click="del(scope.row.id)" v-if="scope.row.status == 0 && auth.accountType == 3">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                title="商品改价"
                :visible.sync="dialogVisible"
                width="30%"
                >
            <div>
                <el-input v-model="updateOrder.amount"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitAmount">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import orderApi from "../../api/order";
    import {mapState} from "vuex";
    import enterpriseApi from "../../api/enterprise";
    import deviceTypeApi from "../../api/deviceType";

    export default {
        data: function () {
            return {
                orders: [],
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
                total: 0,
                loading: false,
                query: {
                },
                payStatuses: [{id: 0, name: "未支付"}, {id: 2, name: "已支付"}],
                dialogVisible: false,
                updateOrder: {

                },
                enterprises: [],
                standards: [],
            }
        },
        computed: {
            ...mapState("auth", {
                auth: state => state
            }),
        },
        mounted: function() {
            this.loadTypes();
            this.loadEnterprises();
          this.loadOrders();
          console.log(this.auth)
        },
        methods: {
            loadOrders: function () {
                this.loading = true;
                orderApi.getAll(this.query, this.pagination).then(result => {
                    this.loading = false;
                    this.orders = result.data;
                    this.total = result.total;
                })
            },
            onQuery: function () {
                this.pagination = {
                    page: 1,
                    pageSize: 10
                }
                this.loadOrders();
            },
            handleSizeChange: function (size) {
                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadOrders();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadOrders();
            },
            onTimeRangeChange: function (val) {
                this.query.startTime = val[0];
                this.query.endTime = val[1];
                console.log(this.query);
            },
            showDialog: function (order) {
                this.dialogVisible = true;
                this.updateOrder = {id: order.id, amount: order.amount};
            },
            submitAmount: function () {
                orderApi.updateAmount(this.updateOrder.id, this.updateOrder.amount).then(() => {
                    this.$message({
                        message: "订单价格更新成功",
                        type: "success"
                    })
                    this.loadOrders();
                    this.dialogVisible = false;
                })
            },
            del: function (id) {
                this.$confirm('确定删除该订单？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    orderApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadOrders();
                    })
                });
            },
            loadEnterprises: function () {
                enterpriseApi.getAll2().then(res => {
                    this.enterprises = res;

                })
            },
            onEpChange: function () {
                console.log(this.query.epId)
                const epId = this.query.epId;
                if(epId) {
                    this.form = {
                        ...this.form,
                        standardId: null
                    }
                    deviceTypeApi.getByEpId(epId).then(res => this.standards = res);
                }
            },
            loadTypes: function () {
                deviceTypeApi.getAll().then(res => this.standards = res);
            }
        }
    }
</script>
